import type {
  TooltipCursor,
  TooltipFormatter,
} from './alignment-picking-tooltip.types';
import { SnapTypeValue } from './web3d-internals';

/**
 * Shows the hovered alignment's name in the shared 3D cursor tooltip while
 * picking. The cursor is shared with every other tool, so whatever formatter
 * was installed before is restored on `clear`.
 */
export class AlignmentPickingTooltip {
  #latestRequest = 0;
  #installed = false;
  #previousFormatter: TooltipFormatter | undefined;

  constructor(private readonly cursor: TooltipCursor) {}

  /** Lookups finishing after a newer `show` or a `clear` are dropped. */
  public async show(resolveName: () => Promise<string>): Promise<void> {
    const request = ++this.#latestRequest;
    const name = await resolveName();
    if (request !== this.#latestRequest) {
      return;
    }
    if (!this.#installed) {
      this.#previousFormatter = this.cursor.tooltipFormatter;
      this.#installed = true;
    }
    this.cursor.tooltipFormatter = (_text, snapType): string =>
      snapType === SnapTypeValue.LINE ? name : '';
  }

  public clear(): void {
    this.#latestRequest++;
    if (!this.#installed) {
      return;
    }
    this.cursor.tooltipFormatter = this.#previousFormatter;
    this.#previousFormatter = undefined;
    this.#installed = false;
  }
}
